import { combineActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../../actions';

//REDUCERS
const { reservation } = actions.customer;
export default handleActions(
  {
    [combineActions(
      reservation.getAsync.toString(),
      reservation.getTmsAsync.toString(),
      reservation.patchTmsAsync.toString(),
      reservation.postAsync.toString(),
      reservation.patchAsync.toString(),
      reservation.set.toString()
    )]: (reservation, { payload }) => {
      return payload;
    }
  },
  Map()
);
